<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-tabs
                class="classify-tabs"
                v-model="queryFormModel.goodsLabelTypeId"
                type="card"
                @tab-click="onQuery()"
            >
                <el-tab-pane
                    label="列表图标签"
                    name="1"
                />
                <el-tab-pane
                    label="图片标签"
                    name="2"
                />
                <el-tab-pane
                    label="文字标签1"
                    name="3"
                />
                <el-tab-pane
                    label="文字标签2"
                    name="4"
                />
                <el-tab-pane
                    label="文字标签3"
                    name="5"
                />
            </el-tabs>
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="labelName"
                    label="标签名称"
                >
                    <el-input
                        v-model="queryFormModel.labelName"
                        placeholder="请输入标签名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="labelCode"
                    label="标签代码"
                >
                    <el-input
                        v-model="queryFormModel.labelCode"
                        placeholder="请输入标签代码"
                    />
                </el-form-item>
                <el-form-item
                    prop="isAvailable"
                    label="是否可用"
                >
                    <el-select
                        v-model="queryFormModel.isAvailable"
                        placeholder="请选择"
                    >
                        <el-option
                            key="1"
                            label="是"
                            value="1"
                        />
                        <el-option
                            key="2"
                            label="否"
                            value="0"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="orderNum"
                    label="序号"
                    min-width="100"
                />
                <el-table-column
                    prop="labelName"
                    label="标签名称"
                    min-width="100"
                />
                <el-table-column
                    prop="labelCode"
                    label="标签代码"
                    min-width="100"
                />
                <el-table-column
                    prop="labelContent"
                    label="标签文本"
                    min-width="100"
                    v-if="queryFormModel.goodsLabelTypeId == 3 || queryFormModel.goodsLabelTypeId == 4"
                    key="labelContent"
                />
                <el-table-column
                    v-else
                    label="标签图片"
                    width="120"
                    key="labelImage"
                >
                    <template slot-scope="scope">
                        <ImageList
                            :data="scope.row.labelImageUrl"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    prop="goodsNum"
                    label="商品数量"
                    min-width="100"
                />
                <el-table-column
                    prop="isAvailable"
                    label="是否可用"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isAvailable ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onGoodsForbidSell(scope.row)"
                        >
                            商品管理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="labelName"
                    label="标签名称"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.labelName"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="labelCode"
                    label="标签代码"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.labelCode"
                        auto-complete="off"
                    />
                </el-form-item>
                <template v-if="addDialog.formModel.goodsLabelTypeId != 1 && addDialog.formModel.goodsLabelTypeId != 2">
                    <el-form-item
                        prop="labelContent"
                        label="标签文本"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelContent"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="color"
                        label="文本颜色"
                        label-width="6em"
                    >
                        <el-color-picker v-model="addDialog.formModel.labelConfig.color"></el-color-picker>
                    </el-form-item>
                    <el-form-item
                        prop="backgroundColor"
                        label="背景颜色"
                        label-width="6em"
                    >
                        <el-color-picker v-model="addDialog.formModel.labelConfig.backgroundColor"></el-color-picker>
                    </el-form-item>
                    <el-form-item
                        prop="borderColor"
                        label="边框颜色"
                        label-width="6em"
                    >
                        <el-color-picker v-model="addDialog.formModel.labelConfig.borderColor"></el-color-picker>
                    </el-form-item>
                    <el-form-item
                        prop="borderRadius"
                        label="圆角"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelConfig.borderRadius"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="margin"
                        label="外边距"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelConfig.margin"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="padding"
                        label="内边距"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelConfig.padding"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="borderStyle"
                        label="边框样式"
                        label-width="6em"
                    >
                        <el-select
                            v-model="addDialog.formModel.labelConfig.borderStyle"
                            placeholder="请选择"
                            clearable
                        >
                            <el-option
                                label="none"
                                value="none"
                            />
                            <el-option
                                label="hidden"
                                value="hidden"
                            />
                            <el-option
                                label="dotted"
                                value="dotted"
                            />
                            <el-option
                                label="dashed"
                                value="dashed"
                            />
                            <el-option
                                label="solid"
                                value="solid"
                            />
                            <el-option
                                label="double"
                                value="double"
                            />
                            <el-option
                                label="groove"
                                value="groove"
                            />
                            <el-option
                                label="ridge"
                                value="ridge"
                            />
                            <el-option
                                label="inset"
                                value="inset"
                            />
                            <el-option
                                label="outset"
                                value="outset"
                            />
                            <el-option
                                label="inherit"
                                value="inherit"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        prop="borderWidth"
                        label="边框大小"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelConfig.borderWidth"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="fontSize"
                        label="字体大小"
                        label-width="6em"
                    >
                        <el-input
                            v-model="addDialog.formModel.labelConfig.fontSize"
                            auto-complete="off"
                        />
                    </el-form-item>
                </template>
                <el-form-item
                    prop="labelImage"
                    label="标签图片"
                    label-width="6em"
                    v-else
                >
                    <upload
                        validate-md5
                        action="/rs/attachment/uploadFileLibrary"
                        :limit="1"
                        v-model="addDialog.formModel.labelImage"
                    />
                </el-form-item>
                <el-form-item
                    prop="orderNum"
                    label="序号"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        v-model.number="addDialog.formModel.orderNum"
                    />
                    越大优先级越高
                </el-form-item>
                <el-form-item
                    prop="isAvailable"
                    label="是否可用"
                    label-width="6em"
                >
                    <el-switch
                        v-model="addDialog.formModel.isAvailable"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>

        <!--商品管理-->
        <el-dialog
            title="商品管理"
            center
            width="1200px"
            :visible.sync="goodsForbidSellDialog.isVisible"
            @closed="onGoodsForbidSellCancel"
        >
            <!-- 内容 -->
            <div class="body">
                <el-form
                    ref="goodsForbidSellDialogQueryForm"
                    class="second-header npa-b"
                    size="small"
                    :inline="true"
                    :model="goodsForbidSellDialog.queryFormModel"
                >
                    <el-form-item
                        prop="goodsName"
                        label="商品名称"
                    >
                        <el-input
                            v-model="goodsForbidSellDialog.queryFormModel.goodsName"
                            placeholder="请输入商品名称"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="goodsSn"
                        label="商品货号"
                    >
                        <el-input
                            v-model="goodsForbidSellDialog.queryFormModel.goodsSn"
                            placeholder="请输入商品货号"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="goodsSendMode"
                        label="发货方式"
                    >
                        <dictionaries-picker
                            type="goodsSendMode"
                            v-model="goodsForbidSellDialog.queryFormModel.goodsSendMode"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="shopTagIdList"
                        label="商品分组"
                    >
                        <RemoteSelect
                            multiple
                            remote="/sp/shopTag/select"
                            placeholder="请输入"
                            :props="{id:'id',name:'labelName'}"
                            v-model="goodsForbidSellDialog.queryFormModel.shopTagIdList"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            @click="onGoodsForbidSellDialogQuery()"
                        >
                            查询
                        </el-button>
                        <el-button
                            type="success"
                            @click="onResetGoodsForbidSellDialog"
                        >
                            重置
                        </el-button>
                    </el-form-item>
                </el-form>

                <div
                    class="ma-b"
                >
                    <el-button-group>
                        <el-button
                            type="success"
                            icon="el-icon-plus"
                            size="small"
                            @click="onAddSelect()"
                        >
                            选择商品
                        </el-button>
                        <el-button
                            type="danger"
                            icon="el-icon-delete"
                            size="small"
                            @click="onDeleteSelectBatch"
                            :disabled="!goodsForbidSellDialog.currentTableSelect.length"
                        >
                            删除
                        </el-button>
                    </el-button-group>
                </div>

                <el-table
                    stripe
                    border
                    size="small"
                    :data="goodsForbidSellDialog.tableData"
                    style="width: 100%"
                    @selection-change="onGoodsForbidSellDialogSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="36"
                    />
                    <el-table-column
                        prop="goodsName"
                        label="商品名称"
                        min-width="100"
                    />
                    <el-table-column
                        prop="goodsSn"
                        label="商品编号"
                        min-width="100"
                    />
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="45"
                    >
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="onDeleteSelect(scope.row.id)"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="ma-t ta-r">
                    <pagination
                        v-model="goodsForbidSellDialog.pagination"
                        @input="onGoodsForbidSellDialogQuery"
                    />
                </div>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    size="small"
                    @click="onGoodsForbidSellCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="选择商品"
            center
            width="1200px"
            :visible.sync="selectDialog.isVisible"
            @closed="onSelectCancel"
        >
            <!-- 表单区 -->
            <el-form
                ref="selectDialogQueryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="selectDialog.queryFormModel"
            >
                <el-form-item
                    prop="goodsName"
                    label="商品名称"
                >
                    <el-input
                        v-model="selectDialog.queryFormModel.goodsName"
                        placeholder="请输入商品名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="goodsSn"
                    label="商品编号"
                >
                    <el-input
                        v-model="selectDialog.queryFormModel.goodsSn"
                        placeholder="请输入商品编号"
                    />
                </el-form-item>
                <el-form-item
                    prop="goodsSendMode"
                    label="发货方式"
                >
                    <dictionaries-picker
                        type="goodsSendMode"
                        v-model="selectDialog.queryFormModel.goodsSendMode"
                    />
                </el-form-item>
                <el-form-item
                    prop="shopTagIdList"
                    label="商品分组"
                >
                    <RemoteSelect
                        multiple
                        remote="/sp/shopTag/select"
                        placeholder="请输入"
                        :props="{id:'id',name:'labelName'}"
                        v-model="selectDialog.queryFormModel.shopTagIdList"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onSelectDialogQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onResetSelectDialog"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>

            <!-- 内容 -->
            <div class="body">
                <!-- 表格 -->
                <el-table
                    stripe
                    border
                    size="small"
                    :data="selectDialog.tableData"
                    style="width: 100%"
                    height="400"
                    row-key="goodsId"
                    ref="selectDialogTable"
                    @selection-change="onSelectDialogSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="36"
                    />
                    <el-table-column
                        prop="mainImageUrl"
                        label="商品图片"
                        width="135"
                    >
                        <template slot-scope="scope">
                            <image-list :data="scope.row.mainImageUrl"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="goodsName"
                        label="商品名称"
                        min-width="100"
                    />
                    <el-table-column
                        prop="goodsSn"
                        label="商品编号"
                        min-width="100"
                    />
                </el-table>

                <!-- 分页 -->
                <div class="ma-t ta-r">
                    <pagination
                        v-model="selectDialog.pagination"
                        @input="onSelectDialogQuery"
                    />
                </div>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onSelectConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onSelectCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'Variable',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                goodsLabelTypeId: '1',
                labelName: '',
                labelCode: '',
                isAvailable: '',
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    goodsLabelTypeId: '',
                    labelName: '',
                    labelCode: '',
                    labelContent: '',
                    labelImage: [],
                    labelConfig: {
                        color: '',
                        backgroundColor: '',
                        borderRadius: '',
                        margin: '',
                        padding: '',
                    },
                    isAvailable: true,
                    orderNum: '',
                },
                // 表单校验规则
                formRules: {
                    labelName: {
                        required: true,
                        message: '请输入标签名称',
                        trigger: 'blur',
                    },
                    labelCode: {
                        required: true,
                        message: '请输入标签代码',
                        trigger: 'blur',
                    },
                    labelContent: {
                        required: true,
                        message: '请输入标签文本',
                        trigger: 'blur',
                    },
                    labelImage: {
                        type: 'array',
                        required: true,
                        message: '请上传标签图片',
                    },
                    isAvailable: {
                        required: true,
                        message: '请选择是否可用',
                    },
                    orderNum: {
                        required: true,
                        message: '请输入序号',
                        trigger: 'blur',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
            selectDialog: {
                // 对话框显示
                isVisible: false,
                // 查询数据
                queryFormModel: {
                    goodsName: '', // 商品名称
                    goodsSn: '', // 商品编号
                    shopTagIdList: [],
                    goodsSendMode: '',
                },
                // 表单数据
                tableData: [],
                // 分页
                pagination: {},
                // 当前选择行
                currentTableSelect: [],
            },
            goodsForbidSellDialog: {
                // 对话框显示
                isVisible: false,
                // 查询数据
                queryFormModel: {
                    goodsLabelId: '',
                    goodsName: '',
                    goodsSn: '',
                    shopTagIdList: [],
                    goodsSendMode: '',
                },
                // 表单数据
                tableData: [],
                // 分页
                pagination: {},
                currentTableSelect: [],
            },
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Gd.GoodsLabel.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.formModel.goodsLabelTypeId = this.queryFormModel.goodsLabelTypeId;
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Gd.GoodsLabel.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
                this.addDialog.formModel.labelConfig = JSON.parse(this.addDialog.formModel.labelConfig);
            });
            this.addDialog.isVisible = true;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Gd.GoodsLabel.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Gd.GoodsLabel.save({
                    ...this.addDialog.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        // 商品管理
        onGoodsForbidSell(row) {
            this.goodsForbidSellDialog.queryFormModel.goodsLabelId = row.id;
            this.$nextTick(() => {
                this.onGoodsForbidSellDialogQuery();
            });
            this.goodsForbidSellDialog.isVisible = true;
        },
        onGoodsForbidSellDialogQuery(pagination) {
            return this.$api.Gd.Goods.selectByPage({
                ...this.goodsForbidSellDialog.queryFormModel,
                ...pagination,
            }).then(json => {
                const res = json.data;
                this.goodsForbidSellDialog.tableData = res.data;
                this.goodsForbidSellDialog.pagination = res.pagination;
            });
        },
        onResetGoodsForbidSellDialog() {
            this.$refs.goodsForbidSellDialogQueryForm.resetFields();
        },
        onGoodsForbidSellDialogSelectionChange(val) {
            this.goodsForbidSellDialog.currentTableSelect = val;
        },
        onGoodsForbidSellCancel() {
            this.goodsForbidSellDialog.isVisible = false;
        },
        onSelectDialogSelectionChange(val) {
            this.selectDialog.currentTableSelect = val;
        },
        onAddSelect() {
            this.selectDialog.isVisible = true;
            this.$nextTick(() => {
                this.onSelectDialogQuery();
            });
        },
        onSelectDialogQuery(pagination) {
            return this.$api.Gd.Goods.selectByPage({
                ...this.selectDialog.queryFormModel,
                ...pagination,
                goodsLabelIdNE: this.goodsForbidSellDialog.queryFormModel.goodsLabelId,
            }).then(json => {
                const res = json.data;
                this.selectDialog.tableData = res.data;
                this.selectDialog.pagination = res.pagination;
            });
        },
        onResetSelectDialog() {
            this.$refs.selectDialogQueryForm.resetFields();
        },
        onSelectConfirm() {
            const ids = this.selectDialog.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            if (ids.length === 0) {
                this.$message({
                    message: '请选择商品',
                    type: 'error',
                });
                return;
            }
            this.$api.Gd.GoodsLabel.saveGoodsGoodsLabel({
                goodsIds: ids.join(','),
                goodsLabelId: this.goodsForbidSellDialog.queryFormModel.goodsLabelId,
            }).then(json => {
                const res = json.data;
                this.$message({
                    message: res.msg,
                    type: 'success',
                });
                this.onGoodsForbidSellDialogQuery(this.goodsForbidSellDialog.pagination);
                this.selectDialog.isVisible = false;
                this.onQuery(this.pagination);
            });
        },
        onSelectCancel() {
            this.selectDialog.isVisible = false;
        },
        onDeleteSelectBatch() {
            const ids = this.goodsForbidSellDialog.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onDeleteSelect(ids.join(','));
        },
        onDeleteSelect(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Gd.GoodsLabel.delGoodsGoodsLabel({
                    goodsIds: ids,
                    goodsLabelId: this.goodsForbidSellDialog.queryFormModel.goodsLabelId,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onGoodsForbidSellDialogQuery(this.goodsForbidSellDialog.pagination);
                    this.onQuery(this.pagination);
                });
            });
        },
    },
};
</script>

<style lang="scss">
</style>
